import { contactChannels } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

export default function ContactChannels() {
  return (
    <section id="channels" className="bg-background-100 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <SectionHeading
            kicker="All Channels"
            title="六条官方联络通道"
            description="请根据事项类型选择对应通道，这样你的信息会更快到达负责的团队。所有邮箱域名统一为 shentong-baoliao.com。"
          />

          <div className="mt-10 md:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {contactChannels.map((channel) => (
              <article
                key={channel.title}
                className={`flex flex-col rounded-lg border p-6 md:p-7 transition-colors ${
                  channel.highlight
                    ? 'bg-foreground-950 border-foreground-950 text-background-100'
                    : 'bg-background-50 border-foreground-950/10 hover:border-primary-300'
                }`}
              >
                <div className="flex items-start justify-between gap-4">
                  <span
                    className={`w-12 h-12 flex items-center justify-center rounded-md ${
                      channel.highlight
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-secondary-100 text-secondary-800'
                    }`}
                  >
                    <i className={`${channel.icon} text-xl`}></i>
                  </span>
                  {channel.highlight ? (
                    <span className="font-mono text-[10px] tracking-[0.16em] uppercase px-2.5 py-1 rounded-full bg-accent-500 text-foreground-950">
                      主通道
                    </span>
                  ) : null}
                </div>

                <h3
                  className={`mt-6 font-heading text-lg font-bold ${
                    channel.highlight ? 'text-background-50' : 'text-foreground-950'
                  }`}
                >
                  {channel.title}
                </h3>
                <p
                  className={`mt-3 font-mono text-sm break-all ${
                    channel.highlight ? 'text-accent-400' : 'text-primary-600'
                  }`}
                >
                  {channel.value}
                </p>
                <p
                  className={`mt-4 text-sm leading-relaxed flex-1 ${
                    channel.highlight ? 'text-background-200' : 'text-foreground-600'
                  }`}
                >
                  {channel.desc}
                </p>

                <div
                  className={`mt-6 pt-5 border-t space-y-2 ${
                    channel.highlight ? 'border-background-50/15' : 'border-foreground-950/10'
                  }`}
                >
                  <p
                    className={`text-xs leading-relaxed ${
                      channel.highlight ? 'text-background-300' : 'text-foreground-500'
                    }`}
                  >
                    {channel.scene}
                  </p>
                  <p
                    className={`flex items-center gap-2 font-mono text-xs ${
                      channel.highlight ? 'text-background-100' : 'text-foreground-800'
                    }`}
                  >
                    <i className="ri-time-line"></i>
                    {channel.response}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}